import React, { useState, useEffect } from "react";
import { GET_GIFT_CARDS, GET_PRODUCTS_BY_ID } from "@app/scripts/utils/queries";
import { shopify } from "@app/scripts/utils/graphql";
import { handleVariantChange, setPricing, disableAddToCartButton } from "@app/scripts/sections/product-details";
import type { GiftCard, VariantChangeArgs, GQLProduct } from "@app/scripts/types";
import { useShopify } from "@app/scripts/react-hooks/shopify";

export const GiftCardOptionDetails = (props: any) => {
  const { normaliseProduct } = useShopify();
  const [giftCards, setGiftCards] = useState<any[]>([]);

  const [eGiftCards, setEGiftCard] = useState<any>({});

  const [loaded, setLoaded] = useState(false);
  const [product, setProduct] = useState();
  const [denominationValue, setDenominationValue] = useState("");
  const [type, setType] = useState(props.type);
  const [hidePhyscialGiftCard, setHidePhyscialGiftCard] = useState(JSON.parse(props.hide_physcial_gc));
  useEffect(() => {
    const radioInputPhysical = document.querySelector(
      'input[name="giftcard_type"][value="physical"]'
    ) as HTMLInputElement;
    const radioInputDigital = document.querySelector(
      'input[name="giftcard_type"][value="digital"]'
    ) as HTMLInputElement;

    if (type === "physical") {
      // Use querySelector to select the radio input by both name and value attributes

      if (radioInputPhysical) {
        radioInputPhysical.setAttribute("checked", "true");
      }
    }
    if (type === "digital") {
      // Use querySelector to select the radio input by both name and value attributes

      if (radioInputDigital) {
        radioInputDigital.setAttribute("checked", "true");
      }
    }
  }, [loaded]);

  useEffect(() => {
    disableAddToCartButton();
    const fetchData = async () => {
      try {
        const res = (await shopify(GET_GIFT_CARDS, {})) as GiftCard;

        if (res?.products?.edges) {
          const giftCardData = res.products.edges.map((edge) => {
            return {
              handle: edge.node.handle,
              priceRange: edge.node.priceRange,
              title: edge.node.title,
              id: edge.node.id,
              variants: {
                nodes: edge.node.variants.nodes.map((variant) => ({
                  id: variant.id.split("/").pop(),
                  price: variant.price,
                })),
              },
            };
          });
          // Sort the giftCardData array by priceRange
          giftCardData.sort(
            (a, b) => parseFloat(a.priceRange.minVariantPrice.amount) - parseFloat(b.priceRange.minVariantPrice.amount)
          );

          const eGiftCardData = giftCardData.find(
            (giftCard) =>
              giftCard.handle === "gift-card" ||
              giftCard.handle === "e-gift-card" ||
              giftCard.handle === "egift-card" ||
              giftCard.handle === "online-gift-card"
          );
          setEGiftCard(eGiftCardData);

          const filteredGiftCards = giftCardData.filter(
            (giftCard) =>
              giftCard.handle !== "gift-card" &&
              giftCard.handle !== "e-gift-card" &&
              giftCard.handle !== "egift-card" &&
              giftCard.handle !== "online-gift-card"
          );

          setGiftCards(filteredGiftCards);
          setLoaded(true);
        }
      } catch (error) {
        throw Error("Error fetching gift cards: --> " + error);
      }
    };
    fetchData();
  }, []);
  const handleVariantChangeWrapper = async (e: React.ChangeEvent, { id, handle }: { id: number; handle: string }) => {
    const getProducts = async () => {
      if (e.target.getAttribute("data-product-id")) {
        const data = await shopify(GET_PRODUCTS_BY_ID(), {
          ids: e.target.getAttribute("data-product-id"),
        });

        //@ts-ignore
        if (data?.nodes) {
          //@ts-ignore
          handleDenominationChange(e);

          const filtered = data.nodes
            ?.filter(
              (product: GQLProduct) => product?.handle && window.location.pathname.includes(`/${product.handle}`)
            )
            ?.map((product: GQLProduct) => normaliseProduct(product));

          //Not getting passes here - kids gift cards returns an empty array

          if (filtered?.length) {
            const element = document.querySelector("[data-json]");
            const jsonText = JSON.stringify(filtered);
            if (element) {
              element.innerHTML = jsonText;

              setProduct(filtered);
            }
          }
        }
      }
    };
    getProducts();

    //DOM Selectors

    const product = JSON.parse((document.querySelector("[data-json]") as HTMLElement)?.innerText);
    const productBISForm = document.querySelector(".product__bis-form") as HTMLFormElement;
    const isGiftCard = JSON.parse(
      (document.querySelector("[data-productisgiftcard]") as HTMLElement)?.innerText || "{}"
    )?.isGiftCard;
    const sizeText = document.querySelector("[data-sizetext]") as HTMLElement;
    const isProduct = (document?.querySelector(".price__container") as HTMLElement)?.dataset?.isproduct === "true";
    const setPricingFunction = setPricing(product.price, product.compare_at_price);
    const errorMessage = document.querySelector("[data-error-messsage]") as HTMLElement;
    const isComingSoon = JSON.parse((document.querySelector("[data-json]") as HTMLElement)?.innerText).tags?.find(
      (tag: any) => tag.toLocaleLowerCase().includes("coming")
    );
    const addToCartWrapper = document.querySelector(".product__add-to-cart");
    const stockLevels = JSON.parse((document.querySelector("[data-productstock]") as HTMLElement)?.innerText)?.map(
      (x: string) => ({
        title: x.split(":")[0],
        level: x.split(":")[1],
      })
    );

    const variantChangeProperties: VariantChangeArgs = {
      e,
      productBISForm,
      product,
      stockLevels,
      isGiftCard,
      sizeText,
      isProduct,
      setPricing: setPricingFunction,
      errorMessage,
      isComingSoon,
      addToCartWrapper,
    };

    handleVariantChange({ e, ...variantChangeProperties });
  };

  const handleDenominationChange = (event: any) => {
    let selectedDenomination;
    const inputElement = document.querySelector('input[name="id"]') as HTMLInputElement;

    if (type === "physical") {
      selectedDenomination = event.target.getAttribute("data-variant-id");
    } else {
      if (event.target.getAttribute("data-variant-id")) {
        selectedDenomination = event.target.getAttribute("data-variant-id");
      } else {
        selectedDenomination = event.target;
      }
    }
    if (inputElement) {
      inputElement.value = selectedDenomination;
      setDenominationValue(inputElement.value);
    }
  };

  const handleRedirect = (urlHandle: string) => {
    const origin = window.location.href;
    const basePath = window.location.origin;
    if (hidePhyscialGiftCard) {
      return;
    }
    if (origin === `${basePath}${urlHandle}`) {
      return;
    } else {
      window.location.assign(`${basePath}${urlHandle}`);
    }
  };
  return (
    <div>
      <div>
        <strong className="text-md product__form-gift-option-title">Select Type</strong>
        {loaded && (
          <div className={`product__variant-buttons ${!hidePhyscialGiftCard ? "grid-cols-2" : "grid-cols-1"}`}>
            {/* //Make sure to add logic to toggle this on and off. */}

            {!hidePhyscialGiftCard && (
              <label className="button button--chip" onClick={() => handleRedirect(`/products/${giftCards[0].handle}`)}>
                <input type="radio" value="physical" name="giftcard_type" />
                <span>PHYSICAL</span>
              </label>
            )}

            <label className="button button--chip" onClick={() => handleRedirect(`/products/${eGiftCards.handle}`)}>
              <input type="radio" value="digital" name="giftcard_type" />
              <span>DIGITAL</span>
            </label>
          </div>
        )}
      </div>
      <strong
        attr-name="{{ products.product.gift_card.select_value }}"
        className="text-md product__form-gift-option-title"
      >
        Select Value
      </strong>

      <div className="product__variant-buttons">
        <div className="grid grid-cols-4 w-full">
          {loaded
            ? type === "physical"
              ? giftCards?.map((giftCard, i) => (
                  <label key={i} className="button button--chip">
                    <input
                      type="radio"
                      value={`A$${giftCard.variants.nodes[0].price.amount}0`}
                      name="giftcard_value"
                      data-product-id={giftCard.id}
                      data-variant-id={giftCard.variants.nodes[0].id}
                      onChange={(e) =>
                        handleVariantChangeWrapper(e, { id: giftCard.variants.nodes[0].id, handle: giftCard.handle })
                      }
                    />
                    <span>${giftCard.priceRange.minVariantPrice.amount.replace(".0", "")}</span>
                  </label>
                ))
              : type === "digital"
              ? eGiftCards?.variants?.nodes?.map((eGiftCard: any, i: number) => (
                  <label key={i} className="button button--chip">
                    <input
                      type="radio"
                      value={`A$${eGiftCard.price.amount}0`}
                      name="giftcard_value"
                      data-product-id={eGiftCards.id}
                      data-variant-id={eGiftCard.id}
                      onChange={(e) => handleVariantChangeWrapper(e, { id: eGiftCard.id, handle: eGiftCards.handle })}
                    />
                    <span>${eGiftCard.price.amount.replace(".0", "")}</span>
                  </label>
                ))
              : null
            : null}
        </div>
      </div>
    </div>
  );
};
